import { activationHelpId, ctaEnterZifyId } from "@/assets/googleTrackIds";
import { Button, Card, Space, Typography } from "@payping/web-components";
import { useAppTranslation } from "@/utils/useAppTranslation";

const changeAdvancedSettlement = () => {
  const { t } = useAppTranslation();

  return (
    <Card.Ant>
      <Card.Meta
        title={t("settlement.attention")}
        description={
          <Space direction={"vertical"} size={"large"} className={"tw-w-full"}>
            <Typography.Text>{t("settlement.banner.desc")}</Typography.Text>
            <Space direction={"horizontal"}>
              <a href={"https://zify.ir/panel/"} target={"_blank"} rel="noreferrer" data-google-track={ctaEnterZifyId}>
                <Button type={"primary"}>{t("settlement.banner.loginZify")}</Button>
              </a>
              <a
                href={"https://payping.ir/blog/%D8%B2%DB%8C%D9%81%D8%A7%DB%8C-%DA%86%DB%8C%D8%B3%D8%AA%D8%9F/"}
                target={"_blank"}
                rel="noreferrer"
                data-google-track={activationHelpId}
              >
                <Button variant={"link"}>{t("settlement.banner.zifyStepHelp")}</Button>
              </a>
            </Space>
          </Space>
        }
      />
    </Card.Ant>
  );
};
export default changeAdvancedSettlement;
